import React from "react";
import SvgLogoColoredGrey from "./LogoColoredGrey";
import SvgLogoFullColor from "./LogoFullColor";
import SvgLogoSquareColoredGrey from "./LogoSquareColoredGrey";
import SvgLogoSquareFullColor from "./LogoSquareFullColor";
export function Logo({ type = "full-color", shape = "full", className = "", }) {
    if (shape === "square") {
        if (type === "colored-grey") {
            return React.createElement(SvgLogoSquareColoredGrey, { className: className });
        }
        else {
            return React.createElement(SvgLogoSquareFullColor, { className: className });
        }
    }
    else {
        if (type === "colored-grey") {
            return React.createElement(SvgLogoColoredGrey, { className: className });
        }
        else {
            return React.createElement(SvgLogoFullColor, { className: className });
        }
    }
}
//# sourceMappingURL=Logo.js.map